// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CaretDownIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from caret-down.svg
 */
export default function CaretDownIcon(props: CaretDownIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CaretDownIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M3.293 5.293a1 1 0 0 1 1.32-.083l.094.083L8 8.585l3.293-3.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-4 4a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1 0-1.414"
        />
      </g>
    </svg>
  );
}
